require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-top-3-ecommerce-user-generated-content-campaigns.json") })
        }
      }, "path---blog-top-3-ecommerce-user-generated-content-campaigns");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-top-3-ecommerce-user-generated-content-campaigns!./.cache/json/blog-top-3-ecommerce-user-generated-content-campaigns.json
// module id = 508
// module chunks = 231608221292675